<!-- src/views/HomePage.vue -->
<template>
  <div class="c-text-column" style="    position: relative;top: -90px;">
    <div class="c-text-between px-container c-flex-wrap c-mt-40">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <span class="c-mb-5">FRANKA ROBOTICS / SCHMALZ</span>
      
        <div class="c-text-align">
          <h1 style="font-size: 40px;font-family: 'Montserrat', sans-serif;text-align: left;">协作机器人泵</h1>
        </div>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
          协作机器人泵能够实现精确的无气真空发生，可靠地拾取气密性或轻微多孔的物体。非常适合拾取与放置操作、装配自动化以及实验室设备处理。完美适用于移动式和固定式机器人系统，即使在无法提供压缩空气的场合也能正常工作。提升每一项操作任务的效率、安全性和精度。
        </span>
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10">
          <router-link to="/contact" class="buttonSite  c-mr-20">立刻联系</router-link>
        </div>
      </div>

      <div class="display-width c-text-align">
        <div style="aspect-ratio:  716/450;">
          <img src="@/assets/images/productsPage/Kopie von Unbenannt (3).jpg"  style="width: 100%;aspect-ratio: 716/450;" />
        </div>
      </div>
    </div>
    <div>
      <div class="line-with-text px-container ">
        <hr class="divider">
        <span class="line-text">产品详情
        </span>
        <hr class="divider">
      </div>
       <div class="c-text-between px-container c-flex-wrap ">
        <div class="display-width c-text-column c-pdr-40"
          style="align-items: flex-start; justify-content: center;">
          <h3>技术规格与详情</h3>
          <div class="c-text-left c-mt-10 c-mb-10">Cobot Pump 兼具高性能与紧凑轻量化的设计。其完全集成的架构无需外部控制器、驱动器或线缆，确保轻松设置和整洁的工作空间。电源和通信通过机器人法兰接口直接传输，实现真正的即插即用操作，并与 Desk 无缝交互。</div>
          <div class="c-text-left c-mt-10 c-mb-10">Cobot Pump 无需压缩空气即可产生高达 750 mbar 的真空，非常适合灵活和移动的自动化场景。</div>
          <div class="c-text-left c-mt-10 c-mb-10">无论是在拾取与放置操作、实验室环境还是装配自动化中使用，用户几乎可以立即开始操作系统，从而最大限度地减少设置时间并提高生产力。</div>
          <strong>规格参数</strong>
          <li class="c-mt-10 c-ml-20"><strong>最大抽气速率:</strong>
            12 L/min
          </li>
          <li class="c-mt-10 c-ml-20"><strong>电压:</strong>
            48 VDC
          </li>
          <li class="c-mt-10 c-ml-20"><strong>最大真空度:</strong>
            750 mbar
          </li>
          <li class="c-mt-10 c-ml-20"><strong>声压级:</strong>
           57 dBA
          </li>
          <li class="c-mt-10 c-ml-20"><strong>重量:</strong>
           57 dBA
          </li>
          <li class="c-mt-10 c-ml-20"><strong>防护等级:</strong>
           IP40
          </li>
          <li class="c-mt-10 c-ml-20"><strong>电气接口:</strong>
          8 针卡扣式连接器
          </li>
          <li class="c-mt-10 c-ml-20"><strong>机械接口:</strong>
          DIN ISO 9409-1-A50
          </li>
          <div class="c-mt-20">
            <a @click="$router.push('/documents#franka-hand')" class="linkTag c-mr-20" target="_blank">
            下载产品手册</a>
            <!-- <a href="https://franka.de/hubfs/Franka%20Hand_Flange.png?hsLang=en" class="linkTag c-mr-20" target="_blank">
            下载产品手册</a> -->
          <a href="https://franka.de/hubfs/Franka%20Cobot%20Pump.zip?hsLang=en" class="linkTag" >
               更多下载/信息 
          </a>
          </div> 
        </div>
        <!-- <div class="display-width c-text-both" style="aspect-ratio: 716/450;">
          <div class="carousel-container">
            <div class="carousel" @mouseenter="pauseCarousel" @mouseleave="resumeCarousel">
              <div class="slides-wrapper" :style="{ transform: `translateX(-${activeIndex * 100}%)` }">
                <div v-for="(img, index) in images" :key="index" class="slide">
                  <img :src="img.src" :alt="img.alt" class="carousel-img">
                </div>
              </div>

              <button class="carousel-btn prev" @click="prevSlide">
                <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 15L2 8L10 1" stroke="white" stroke-width="2"></path>
                </svg>
              </button>
              <button class="carousel-btn next" @click="nextSlide">
                <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 15L9 8L1 1" stroke="white" stroke-width="2"></path>
                </svg>
              </button>

              <div class="carousel-indicators">
                <span v-for="(img, index) in images" :key="'indicator-' + index"
                  :class="{ active: activeIndex === index }" @click="goToSlide(index)"></span>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">须知事项</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 80px;">
      <div class="display-width c-text-column ">
        <h1 class="c-text-left">兼容性</h1>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
         Cobot Pump 兼容 Franka Robotics 的所有机器人。通过 Desk 操作时，可使用随机器人免费提供的专用 App 进行启用，开箱即可快速、轻松地启动。
        </span>
      </div>
      <div class="display-width c-text-column ">
        <h1 class="c-text-left">所需知识</h1>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
         对机器人设置、Desk 以及安全硬件安装有基本的了解。
        </span>
      </div>
    </div>
    <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 80px;">
      <div class="display-width c-text-column ">
        <h1 class="c-text-left">安装方法</h1>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
         轻松将 Cobot Pump 安装并设置到您的 Franka 机器人上。
        </span>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
         使用随附的螺钉将 Cobot Pump 固定到法兰上，将集成的电源与数据线缆连接到法兰上的末端执行器接口，然后通过 Desk 界面激活。几分钟内，您的机器人即可准备就绪，执行操作任务。
        </span>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
         在安装和操作之前，您必须仔细阅读 Cobot Pump 的操作说明，以确保安全、正确地完成设置。
        </span>
      </div>
      <div class="display-width c-text-column ">
        <h1 class="c-text-left">应用场景</h1>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
         适用于拾取与放置任务、装配自动化、实验室处理以及研究。
        </span>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
         Cobot Pump 能够实现精确的无气真空发生，非常适合处理气密性或轻微多孔的物体。
        </span>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
         它无缝支持移动式和固定式协作机器人应用，尤其是在没有压缩空气基础设施的环境中。
        </span>
      </div>
    </div>
     <div class="line-with-text px-container">
        <hr class="divider">
        <span class="line-text">制造商详情</span>
        <hr class="divider">
      </div> 
      <div class="px-container" style="text-align: left; ">Cobot Pump 是与 Schmalz 合作开发的，由 Franka Robotics 销售。</div>
     <div class="line-with-text px-container">
        <hr class="divider">
        <span class="line-text">组件</span>
        <hr class="divider">
      </div> 
      <div class="c-text-between px-container c-flex-wrap">
        <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;">
          <h1>探索第三方配件</h1>
        
          <div class="c-text-justify-start c-flex-wrap c-mt-20 c-mb-10"> 
            <div class="buttonSite">
              <!-- documents -->
              <!-- <a href="/#/resources" target="_blank">获取资料</a> -->
              <a  @click="$router.push('/accessories')"  target="_self">获取更多</a>
            </div>
          </div>  
        </div>
        <div class="display-width">
          <img src="@/assets/images/productsPage/Murrplastik_01 (1).jpg" alt=""
            style="    height: auto; max-width: 100%;">
        </div>
      </div>

  </div>
</template>

<script>

import backgroundImage from "@/assets/images/productsPage/FR3 move new 6.png";
export default {
  metaInfo() {
    return {
      title: this.$route.meta.title, // 从路由获取标题
      meta: [
        {
          name: 'keywords',
          content: this.$route.meta.metaTags[0]['content']
        }
      ]
    }
  },
  name: 'HomePage',
  data() {
    return {
      activeIndex: 0,
      carouselInterval: null,
      isTransitioning: false,
      images: [
        { src: require('@/assets/images/productsPage/_Frank Robotics0304 1_resized (1).jpg'), alt: 'Franka Robotics产品图片1' },
        { src: require('@/assets/images/productsPage/_Frank Robotics0363_RESIZED.jpg'), alt: 'Franka Robotics产品图片2' },
        { src: require('@/assets/images/productsPage/_Frank Robotics0443_RESIZED.jpg'), alt: 'Franka Robotics产品图片3' },
        { src: require('@/assets/images/productsPage/_Frank Robotics0464_RESIZED.jpg'), alt: 'Franka Robotics产品图片4' },
        { src: require('@/assets/images/productsPage/_Frank Robotics0570_RESIZED.jpg'), alt: 'Franka Robotics产品图片5' },
      ],
      iframe1: '2',
      iframe2: '2',
      backgroundImage: backgroundImage,
      tableData: [
        { name: '基于工作流的应用程序编程', DESK: true, RIDE: false, FCI: false },
        { name: '快速原型设计实验和演示 ', DESK: true, RIDE: false, FCI: false },
        { name: '执行机器人任务', DESK: true, RIDE: false, FCI: true },
        { name: '开发自定义应用程序', DESK: false, RIDE: true, FCI: false },
        { name: '连接第三方硬件', DESK: false, RIDE: true, FCI: true },
        { name: '连接外部资源', DESK: false, RIDE: true, FCI: true },
        { name: '1 kHz 力矩、位置和速度控制 ', DESK: false, RIDE: false, FCI: true },
        { name: '1 kHz 传感器信号和机器人状态的测量', DESK: false, RIDE: false, FCI: true },
        { name: '访问机器人运动学和动力学模型', DESK: false, RIDE: false, FCI: true },
        { name: '与ROS和MATLAB & Simulink的集成', DESK: false, RIDE: false, FCI: true },
      ]
    }

  },
  mounted() {
    this.startCarousel();
  },
  beforeUnmount() {
    clearInterval(this.carouselInterval);
  },
  methods: {
    startCarousel() {
      this.carouselInterval = setInterval(() => {
        this.nextSlide();
      }, 5000);
    },
    nextSlide() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;

      this.activeIndex = (this.activeIndex + 1) % this.images.length;

      setTimeout(() => {
        this.isTransitioning = false;
      }, 500); // 与过渡时间保持一致
    },
    prevSlide() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;

      this.activeIndex = (this.activeIndex - 1 + this.images.length) % this.images.length;

      setTimeout(() => {
        this.isTransitioning = false;
      }, 500);
    },
    goToSlide(index) {
      if (this.isTransitioning || index === this.activeIndex) return;
      this.isTransitioning = true;

      this.activeIndex = index;

      setTimeout(() => {
        this.isTransitioning = false;
      }, 500);
    },
    pauseCarousel() {
      clearInterval(this.carouselInterval);
    },
    resumeCarousel() {
      this.startCarousel();
    }
  }
};
</script>
<style scoped>
.newBack:hover {
  background-color: #1b2f36;
  color: white;
}

.desktop-image {
  display: block;
  width: 100%;
}

.mobile-image {
  display: none;
  width: 100%;
}

@media (max-width: 999px) {
  .desktop-image {
    display: none;
  }
  .mobile-image {
    display: block;
  }
}

/* 新增轮播图样式 - 水平滑动效果 */
.carousel-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.carousel {
  position: relative;
  width: 100%;
  height: 100%;
}

.slides-wrapper {
  display: flex;
  height: 100%;
  transition: transform 0.5s ease;
  will-change: transform;
}

.slide {
  flex: 0 0 100%;
  min-width: 100%;
  position: relative;
}

.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0);
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease;
}

.carousel-btn:hover {
  /* background: rgba(0,0,0,0.8); */
}

.carousel-btn.prev {
  left: 15px;
}

.carousel-btn.next {
  right: 15px;
}

.carousel-indicators {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 10;
}

.carousel-indicators span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: background 0.3s ease;
}

.carousel-indicators span.active {
  background: white;
}

li::marker {
  unicode-bidi: isolate;
  font-variant-numeric: tabular-nums;
  text-transform: none;
  text-indent: 0px !important;
  text-align: start !important;
  text-align-last: start !important;
}

.flex-width {
  width: calc(100% / 6);
}

@media (max-width: 1260px) {
  .flex-width {
    width: calc(100% / 4);
  }
}

@media (max-width: 999px) {
  .flex-width {
    width: calc(100% / 3);
  }
}

@media (max-width: 747px) {
  .flex-width {
    width: calc(100% / 2);
  }
}

@media (max-width: 150px) {
  .flex-width {
    width: 100%
  }
}

.title-width {
  width: 33.33%;
}

/* 屏幕宽度小于 900px 时，一行展示 2 个 */
@media (max-width: 899px) {
  .title-width {
    width: 100%
  }
}

.action-height {
  height: 400px;
  background-color: #d5dbdc;
  position: relative;
}

.action-width {
  width: calc(33% - 40px);
}

/* 屏幕宽度小于 900px 时，一行展示 2 个 */
@media (max-width: 1029px) {
  .action-width {
    width: calc(50% - 40px);
  }

  .action-height {
    height: 200px;
    background-color: #d5dbdc;
  }
}

/* 屏幕宽度小于 600px 时，一行展示 1 个 */
@media (max-width: 599px) {
  .action-width {
    width: 100%;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  border: 1px solid black;
  padding: 5px;
  text-align: left;
}
</style>